/* eslint-disable */
import { ofType, ActionsObservable } from "redux-observable";
import { ajax } from "rxjs/ajax";
import { switchMap, catchError } from "rxjs/operators";
import { activityTypes } from "../actions/activity";
import { API_URL } from "../config/settings";
import { Headers } from "../utils/Headers";
import { toast } from "react-toastify";

export const getActivityListEpic = (action$) => {
  return action$.pipe(
    ofType(activityTypes.GET_ACTIVITY),
    switchMap(({ payload }) => {
      return ajax({
        url: `${API_URL}/activity/list`,
        method: "POST",
        headers: Headers.auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) => {
          return ActionsObservable.create((obs) => {
            obs.next({
              type: activityTypes.GET_ACTIVITY_SUCCESS,
              payload: response.payload.docs,
            });
            obs.complete();
          });
        }),
        catchError((err) => {
          return ActionsObservable.create((obs) => {
            if (err.status === 401) {
              window.location.href = "/login";
            } else {
              toast.error(err.response.message);
            }
          });
        })
      );
    })
  );
};
